import { useState } from 'react';
import '@/shared/plan/events.quiz-trial-discount';
import { trackEvent } from '@zep/logger/tracking';
import { useTrialEndDiscount } from '@/shared/plan/useTrialEndDiscount';
import { trialEndDiscountStorage } from '../storage';
import { openTrialEndDiscountModal } from './openTrialEndDiscountModal';
import { type TrialEndBannerState, TrialEndDiscountBanner } from './TrialEndDiscountBanner';
import { useIsTrialEndDiscountSuppressed } from './useIsTrialEndDiscountSuppressed';

/**
 * GNB 위 할인 배너 마운트 (PRD 솔루션 6, S6-03/07).
 *
 * X 는 세션 동안 숨김이지만, "할인 종료"(=0) 상태의 X 는 영구 제거다
 * (Figma 29139:3344 주석: 종료를 인지시키기 위해 1회만 노출).
 */
export const TrialEndDiscountBannerContainer = () => {
  const discount = useTrialEndDiscount();
  const [dismissedBannerKey, setDismissedBannerKey] = useState<string | null>(null);
  const isSuppressedPath = useIsTrialEndDiscountSuppressed();
  const windowEndIso = discount.windowEnd?.toISOString() ?? null;
  const dismissalKey = windowEndIso;
  if (isSuppressedPath) return null;
  if (discount.status === 'none' || !windowEndIso || dismissedBannerKey === dismissalKey) {
    return null;
  }
  if (trialEndDiscountStorage.isBannerDismissed(windowEndIso)) return null;
  if (discount.status === 'ended' && trialEndDiscountStorage.isEndedClosed(windowEndIso)) {
    return null;
  }
  const state = discount.status as TrialEndBannerState;
  return <TrialEndDiscountBanner state={state} remainingMs={discount.remainingMs} discountRate={discount.discountRate} onDetailClick={() => {
    trackEvent('quiz_trial_discount_banner_click', {
      state
    });
    openTrialEndDiscountModal(discount, 'banner');
  }} onClose={() => {
    if (state === 'ended') {
      trialEndDiscountStorage.markEndedClosed(windowEndIso);
    } else {
      trialEndDiscountStorage.dismissBanner(windowEndIso);
    }
    setDismissedBannerKey(dismissalKey);
  }} data-sentry-element="TrialEndDiscountBanner" data-sentry-component="TrialEndDiscountBannerContainer" data-sentry-source-file="TrialEndDiscountBannerContainer.tsx" />;
};